export const FRAME_SIZES = {
    67: 'Medium',
    66: 'Large',
    68: 'Small',
    235: 'Extra Large',
};
